var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disabled && _vm.printMode)?_c('span',{staticClass:"showText"},[_vm._v(_vm._s(_vm.userName))]):_c('el-input',{attrs:{"size":_vm.size,"value":_vm.userName,"readonly":"readonly","suffix-icon":"el-icon-user"}})
}
var staticRenderFns = []

export { render, staticRenderFns }